import { memoize } from 'lodash'

/**
 * Below is a list of all global keys that are mapped for GlobalHotKeys
 */
export const globalKeyMap = {
  COMMAND_K: 'command+k',
  CONTROL_K: 'ctrl+k',
}

/**
 * Below is a list of all keys that are mapped for HotKeys in local scoped components (i.e.
 * submitting a comment)
 */
export const localKeyMap = {
  BACKSPACE: 'Backspace',
  COMMAND_ENTER: 'meta+enter',
  CONTROL_ENTER: 'ctrl+enter',
  SHIFT_ENTER: 'shift+enter',
  DOWN_ARROW: 'ArrowDown',
  ENTER: 'Enter',
  ESC: 'Escape',
  UP_ARROW: 'ArrowUp',
}

/**
 * Returns the OS of the user based on what
 */
const getOS = memoize((): string => {
  const platform = navigator.userAgent.toLowerCase()

  if (platform.includes('mac')) {
    return 'Mac'
  } else if (platform.includes('win')) {
    return 'Windows'
  } else {
    return 'Other'
  }
})

/**
 * Returns the control key based on the OS of the user as either command or control followed by
 * the suffix element
 */
export function controlKey(suffixElement: string | JSX.Element) {
  let command: string

  const os = getOS()
  if (os === 'Mac') {
    command = '⌘'
  } else {
    command = 'Ctrl+'
  }

  if (typeof suffixElement === 'string') {
    return `${command}${suffixElement}`
  }

  return (
    <>
      {command}
      {suffixElement}
    </>
  )
}
